import React from 'react';

export default function NotificationsIcon() {
    return (
        <div className="top-level-nav__item" data-globalnav-notifications-dropdown>
            <span className="top-level-nav__item__notification-icon" />
        </div>
    );
}
